import callAPI from '../../../commonservices/APIRequests';
import { downloadFile } from '../../../commonservices/CommonMethods';
import { LOADERINV, LOADERINVHIS, LOADERINVSEARCH, SETINITIALLENDERINVENTORY, SETINITIALLENDERINVENTORYHISTORY, SETLENDERINVENTORY, SETLENDERINVENTORYHISTORY, SETLENDERINVENTORYSEARCH, setTitleCount, ISGETINVENTORYBYSEARCH } from '../../Reducers/Lender/Inventory';
import { setSharedNotes } from '../../Reducers/Notes';
import { setIsNotificationInProgress, setCsvData } from '../../Reducers/Shared';
export const getInventory = (filtersParams, isInitialCall = false) => {

    return dispatch => {

        dispatch(LOADERINV(true));

        return callAPI.post('/lender/api/v1/lender/getLenderInventory', filtersParams)
            .then((response) => {

                if (response.status === 200) {

                    const counts = {
                        averageDaysFloored: response.data ? response.data.averageDaysFloored : 0,
                        carsFloored: response.data ? response.data.carsFloored : 0,
                        dealerMissingTitles: response.data ? response.data.dealerMissingTitles : 0,
                        lienHolderMissingTitles: response.data ? response.data.lienHolderMissingTitles : 0,
                        supplierMissingTitles: response.data ? response.data.supplierMissingTitles : 0
                    }

                    response.data.vehicles.forEach(item => {

                        let titleStatusForFilter = '';

                        if (item.titleStatus) {

                            titleStatusForFilter = item.titleStatus.split(' - ');
                            titleStatusForFilter = titleStatusForFilter.length > 1 ? titleStatusForFilter[0] + ' ' + titleStatusForFilter[1] : titleStatusForFilter[0];

                        }

                        item.titleStatusForFilter = titleStatusForFilter;

                    })

                    if (isInitialCall) {

                        dispatch(SETINITIALLENDERINVENTORY(response.data.vehicles ? response.data.vehicles : []))

                    }

                    dispatch(SETLENDERINVENTORY({
                        inventory: response.data.vehicles ? response.data.vehicles : [],
                        inventoryCounts: counts,
                        dataExists: response?.data?.vehicles?.length ? true : false
                    }))

                    dispatch(LOADERINV(false));

                }
                else {
                    dispatch(SETLENDERINVENTORY({
                        inventory: [],
                        inventoryCounts: {},
                        dataExists: false
                    }))
                    dispatch(LOADERINV(false));

                }

            })


    }

}

export const getInventoryHistory = (filtersParams, isInitialCall = false) => {

    return dispatch => {

        dispatch(LOADERINVHIS(true));

        return callAPI.post('/lender/api/v1/lender/getLenderInventoryHistory', filtersParams)
            .then((response) => {

                if (response.status === 200) {

                    response.data.vehicles.forEach(item => {

                        let titleStatusForFilter = '';

                        if (item.titleStatus) {

                            titleStatusForFilter = item.titleStatus.split(' - ');
                            titleStatusForFilter = titleStatusForFilter.length > 1 ? titleStatusForFilter[0] + ' ' + titleStatusForFilter[1] : titleStatusForFilter[0];

                        }

                        item.titleStatusForFilter = titleStatusForFilter;

                    })

                    if (isInitialCall) {

                        dispatch(SETINITIALLENDERINVENTORYHISTORY(response.data.vehicles ? response.data.vehicles : []))

                    }

                    dispatch(SETLENDERINVENTORYHISTORY({
                        inventoryHistory: response.data.vehicles ? response.data.vehicles : [],
                        dataExists: response?.data?.vehicles?.length ? true : false
                    }))

                    dispatch(LOADERINVHIS(false));

                }
                else {
                    dispatch(SETLENDERINVENTORYHISTORY({
                        inventoryHistory: [],
                        dataExists: response?.data?.vehicles?.length ? true : false
                    }))

                    dispatch(LOADERINVHIS(false));

                }

            })

    }

}

export const getDownloadCsvReq = async (data) => {
    const req = {
        filter: data,
        reportType: 'Inventory Search',
        report: true
    }

    const response = await callAPI.post('/inventory/api/v1/inventory/getLenderInventorySearch', req)
    if (response.status === 200) {
        return response
    }
    else {
        return response
    }
}


export const getCsvDownload = (data) => {

    return dispatch => {
        const req = {
            documentId: data?._id ?? '',
            type: 'notification requests'
        }

        return callAPI.get('/lender/api/v1/dealer/getDocument', req)
            .then((response) => {
                if (response.status === 200) {
                    downloadFile(response.data?.url, response.data?.fileName)
                        .then(isDownloaded => {
                            if (isDownloaded) {
                                dispatch(getOnClose(data, 'download'))
                            }
                        })

                }
            })
    }
}


export const getNotifications = () => {
    return dispatch => {
        return callAPI.get('/inventory/api/v1/inventory/getNotificationRequests')
            .then(res => {
                if (res.status === 200) {
                    dispatch(setCsvData(res.data?.requests ?? []))

                    if (res.data?.requests?.length > 0 && res.data?.requests?.some(item => item.status.toLowerCase().includes('in progress'))) {
                        dispatch(setIsNotificationInProgress(true))
                    } else {
                        dispatch(setIsNotificationInProgress(false))
                    }
                }
            })
    }
}

export const getTitleNotifications = (type = false) => {
    return dispatch => {
        return callAPI.get('/tms/api/v1/inventory/getNotificationRequests')
            .then(res => {
                if (res.status === 200) {
                    dispatch(setCsvData(res.data?.requests ?? []))

                    if (res.data?.requests?.length > 0 && res.data?.requests?.some(item => item.status.toLowerCase().includes('in progress'))) {
                        dispatch(setIsNotificationInProgress(true))
                    } else {
                        dispatch(setIsNotificationInProgress(false))
                    }
                }
            })
    }
}

export const getOnClose = (data, type = '') => {
    return dispatch => {
        const req = {
            requestId: data._id
        }
        if (type === 'download') {
            req.downloaded = true
        }

        return callAPI.post('/inventory/api/v1/inventory/handleNotificationRequests', req)
            .then(response => {
                if (response.status == 200) {
                    dispatch(getNotifications())
                }
            })

    }
}


export const getInventoryBySearch = (filtersParams) => {
    return dispatch => {

        dispatch(LOADERINVSEARCH(true));
        return callAPI.post('/inventory/api/v1/inventory/getLenderInventorySearch', { ...filtersParams, searchType: 'inventory-search' })
            .then((response) => {

                if (response.status === 200) {

                    const counts = {
                        averageDaysFloored: response.data ? response.data.averageDaysFloored : 0,
                        carsFloored: response.data ? response.data.carsFloored : 0,
                        dealerMissingTitles: response.data ? response.data.dealerMissingTitles : 0,
                        lienHolderMissingTitles: response.data ? response.data.lienHolderMissingTitles : 0,
                        supplierMissingTitles: response.data ? response.data.supplierMissingTitles : 0
                    }

                    response.data.vehicles.forEach(item => {

                        let titleStatusForFilter = '';

                        if (item.titleStatus) {

                            titleStatusForFilter = item.titleStatus.split(' - ');
                            titleStatusForFilter = titleStatusForFilter.length > 1 ? titleStatusForFilter[0] + ' ' + titleStatusForFilter[1] : titleStatusForFilter[0];

                        }

                        item.titleStatusForFilter = titleStatusForFilter;

                    })
                    dispatch(SETLENDERINVENTORYSEARCH({
                        inventorySearch: response.data.vehicles ? response.data.vehicles : [],
                        inventoryCounts: counts,
                        totalCount: response.data?.vehicleCount ?? 0,
                        inventoryFilters: true
                    }))
                    dispatch(setSharedNotes());
                    dispatch(LOADERINVSEARCH(false));
                    dispatch(ISGETINVENTORYBYSEARCH(false))
                }
                else {

                    dispatch(SETLENDERINVENTORYSEARCH({
                        inventorySearch: [],
                        inventoryCounts: {},
                        totalCount: 0,
                        inventoryFilters: false
                    }
                    ))
                    dispatch(LOADERINVSEARCH(false));
                    dispatch(ISGETINVENTORYBYSEARCH(false))
                }

            })


    }

}

export const getInventoryCounts = () => {

    return dispatch => {

        return callAPI.get('/lender/api/v1/lender/getLenderInventoryCounts', {})
            .then((response) => {

                if (response.status === 200) {
                    dispatch(setTitleCount(response.data));
                }
                else {

                    dispatch(setTitleCount({}));

                }
            })

    }

}